import React, { useRef, useEffect } from 'react';
import './chennaigfc.css';
import ChennaiGfcImg from './../../../../../assets/images/blogs/gfcchennaiblog30-10-2025.jpg';
import favicon from "./../../../../../assets/images/favicon.ico"; // Corrected favicon path
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom'

const ChennaiGfc = () => {
   const navigate = useNavigate(); 
  const contentRef = useRef(null);

  const handleDownloadPdf = () => {
    const container = contentRef.current; // Use the ref for the main container

    if (!container) {
      console.error("Could not find the element to convert to PDF.");
      alert("Error: Could not find content to generate PDF.");
      return;
    }

    const downloadButton = document.querySelector('.chennaigfcblog-download-button');
    if (downloadButton) {
      downloadButton.style.display = 'none';
    }

    // Add PDF-specific class to container
    container.classList.add('chennaigfcblog-pdf-mode');

    // Store original styles for elements that might have animations/transitions
    const elementsToReset = container.querySelectorAll('.chennaigfcblog-section, .chennaigfcblog-main-title, .chennaigfcblog-banner-image, .chennaigfcblog-table, .chennaigfcblog-call-to-action');
    const originalStyles = new Map();

    elementsToReset.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter,
        opacity: el.style.opacity
      });

      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
      el.style.opacity = '1'; // Ensure visibility
    });

    // Fix banner height for PDF
    const bannerSection = container.querySelector('.chennaigfcblog-banner');
    if (bannerSection) {
      bannerSection.style.height = 'auto'; // Allow content to dictate height
      bannerSection.style.minHeight = '200px'; // Ensure a minimum height for banner content
      bannerSection.style.padding = '40px 20px'; // Consistent padding
    }

    // Ensure images are fully loaded and visible
    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
      // Prevent lazy loading issues if any, by forcing display
      img.style.display = 'block';
    });

    // Wait a moment for styles to apply
    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
        imageTimeout: 0,
        removeContainer: false
      }).then(canvas => {
        // Remove PDF-specific class
        container.classList.remove('chennaigfcblog-pdf-mode');

        // Restore original styles
        elementsToReset.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
            el.style.opacity = original.opacity;
          }
        });

        // Restore banner section
        if (bannerSection) {
          bannerSection.style.height = '';
          bannerSection.style.minHeight = '';
          bannerSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Define margins for the PDF
        const marginLeft = 10; // 10mm gap on the left
        const marginRight = 10; // 10mm gap on the right to maintain symmetry and prevent cutting
        const availableWidth = pdfWidth - marginLeft - marginRight;

        // Calculate scaling factor to fit the canvas content within the available width
        const scaleFactor = availableWidth / canvasWidth;

        // Apply the scale factor to both width and height to maintain aspect ratio
        const imgWidth = canvasWidth * scaleFactor;
        const imgHeight = canvasHeight * scaleFactor;

        // Calculate the number of pages needed for vertical content overflow
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) {
            pdf.addPage();
          }
          // Add image to PDF, using marginLeft for the x coordinate
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }

        pdf.save('H-Cura_GFC_Chennai_Blog.pdf'); // Updated filename
      }).catch(error => {
        console.error('Error generating PDF:', error);
        alert('Failed to generate PDF. Please try again.');

        // Remove PDF-specific class
        container.classList.remove('chennaigfcblog-pdf-mode');

        // Restore original styles on error
        elementsToReset.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
            el.style.opacity = original.opacity;
          }
        });

        // Restore banner section
        if (bannerSection) {
          bannerSection.style.height = '';
          bannerSection.style.minHeight = '';
          bannerSection.style.padding = '';
        }
      }).finally(() => {
        if (downloadButton) {
          downloadButton.style.display = 'block';
        }
      });
    }, 100);
  };

  useEffect(() => {
    document.title = "Best GFC Hair Regrowth Treatment in Chennai | H-Cura Clinic";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Discover why H-Cura is Chennai’s best GFC hair regrowth clinic. Trusted experts, advanced technology, and visible results for hair fall and thinning in 2025."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best GFC hair treatment in Chennai, GFC hair regrowth clinic Chennai, hair fall treatment Chennai, advanced GFC therapy, Growth Factor Concentrate hair treatment, non-surgical hair regrowth, PRP vs GFC Chennai, hair loss solution Chennai, H-Cura Clinic, hair restoration clinic Chennai"
      );
    }
    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/best-gfc-hair-regrowth-treatment-in-chennai");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/best-gfc-hair-regrowth-treatment-in-chennai");
      document.head.appendChild(canonicalLink);
    }
    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);





  return (
    <>
      {/* Attach the ref to the main content div */}
      <div className="chennaigfcblog-container" ref={contentRef}>
        <div className="chennaigfcblog-banner">
          <img src={ChennaiGfcImg} alt="GFC Hair Regrowth Treatment in Chennai" className="chennaigfcblog-banner-image" />
          <div className="chennaigfcblog-banner-overlay"></div>
          <h1 className="chennaigfcblog-main-title">Best GFC Hair Regrowth Treatment in Chennai | <span className="chennaigfcblog-green-text">H-Cura Clinic</span></h1>
          <button className="chennaigfcblog-banner-button" onClick={() => navigate('/bookconsultation')} >Book Consultation</button>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-introduction chennaigfcblog-fade-in">
          <p className="chennaigfcblog-paragraph">
            Hair loss in Chennai has become a major concern due to stress, pollution, and hormonal changes. For those seeking advanced hair restoration, GFC Hair Therapy (Growth Factor Concentrate) is the top choice in 2025.
          </p>
          <p className="chennaigfcblog-paragraph">
            At H-Cura Clinic, Chennai, patients get access to GFC hair regrowth treatments that are safe, natural, and effective, making it the best hair regrowth treatment in Chennai. Many people compare PRP vs GFC therapy to understand which solution delivers faster hair regrowth and visible results.
          </p>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">Why Choose GFC Hair Therapy for Hair Regrowth in Chennai</h2>
          <p className="chennaigfcblog-paragraph">
            GFC Hair Therapy is a cutting-edge hair restoration treatment in Chennai that stimulates dormant hair follicles using your own growth factors.
          </p>
          <p className="chennaigfcblog-paragraph chennaigfcblog-key-reasons">Key reasons to choose GFC therapy in Chennai:</p>
          <ul className="chennaigfcblog-list">
            <li className="chennaigfcblog-list-item">High concentration of growth factors ensures faster results.</li>
            <li className="chennaigfcblog-list-item">Non-invasive procedure with minimal discomfort.</li>
            <li className="chennaigfcblog-list-item">Suitable for both men and women experiencing hair thinning.</li>
            <li className="chennaigfcblog-list-item">Long-lasting results with fewer sessions compared to PRP.</li>
          </ul>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">How GFC Hair Treatment Works</h2>
          <p className="chennaigfcblog-paragraph">
            GFC (Growth Factor Concentrate) therapy works by isolating growth factors from your blood and injecting them into the scalp to stimulate new hair growth naturally.
          </p>
          <p className="chennaigfcblog-paragraph chennaigfcblog-step-process">Step-by-step process at H-Cura Clinic, Chennai:</p>
          <ol className="chennaigfcblog-ordered-list">
            <li className="chennaigfcblog-list-item">Blood Collection: A small blood sample is drawn.</li>
            <li className="chennaigfcblog-list-item">GFC Extraction: Growth factors like PDGF, VEGF, EGF, and IGF are separated using advanced equipment.</li>
            <li className="chennaigfcblog-list-item">Scalp Injection: Concentrated GFC is injected into areas of thinning hair or bald patches.</li>
            <li className="chennaigfcblog-list-item">Hair Regrowth Activation: Dormant follicles are stimulated, resulting in visible hair regrowth.</li>
          </ol>
          <p className="chennaigfcblog-paragraph">
            Because GFC works directly with your body’s regenerative system, it offers faster, more visible hair regrowth than traditional methods.
          </p>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">Benefits of GFC Hair Therapy in Chennai</h2>
          <ul className="chennaigfcblog-list">
            <li className="chennaigfcblog-list-item"><span className="chennaigfcblog-bold-text">Natural &amp; Safe:</span> Uses your own blood; 100% chemical-free.</li>
            <li className="chennaigfcblog-list-item"><span className="chennaigfcblog-bold-text">Non-Surgical:</span> Minimal downtime; resume daily activities immediately.</li>
            <li className="chennaigfcblog-list-item"><span className="chennaigfcblog-bold-text">Reduces Hair Fall:</span> Stops active shedding within weeks.</li>
            <li className="chennaigfcblog-list-item"><span className="chennaigfcblog-bold-text">Stimulates New Growth:</span> Reactivates dormant follicles.</li>
            <li className="chennaigfcblog-list-item"><span className="chennaigfcblog-bold-text">Improves Scalp Health:</span> Enhances circulation and nourishment for stronger, thicker hair.</li>
            <li className="chennaigfcblog-list-item"><span>Effective for Men &amp; Women:</span> Treats androgenic alopecia, postpartum hair fall, and stress-related hair loss.</li>
          </ul>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">Who Can Benefit from GFC Hair Therapy</h2>
          <ul className="chennaigfcblog-list">
            <li className="chennaigfcblog-list-item">Individuals with early-stage hair thinning in Chennai.</li>
            <li className="chennaigfcblog-list-item">People with receding hairlines or patchy hair loss.</li>
            <li className="chennaigfcblog-list-item">Postpartum women experiencing hair fall.</li>
            <li className="chennaigfcblog-list-item">People with stress-induced or hormonal hair loss.</li>
            <li className="chennaigfcblog-list-item">Anyone looking for non-surgical, natural hair regrowth in Chennai.</li>
          </ul>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">How Many GFC Sessions Are Needed for Visible Results</h2>
          <p className="chennaigfcblog-paragraph">
            The number of sessions depends on hair loss severity, scalp condition, and individual response:
          </p>
          <div className="chennaigfcblog-table-container">
            <table className="chennaigfcblog-table">
              <thead>
                <tr>
                  <th>Hair Loss Stage</th>
                  <th>Sessions Recommended</th>
                  <th>Frequency</th>
                  <th>Visible Results</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Mild Hair Fall</td>
                  <td>3–4</td>
                  <td>Every 3–4 weeks</td>
                  <td>Hair growth is enhanced</td>
                </tr>
                <tr>
                  <td>Moderate Thinning</td>
                  <td>4–6</td>
                  <td>Every 3–4 weeks</td>
                  <td>Noticeable new hair growth after 3–4 sessions</td>
                </tr>
                <tr>
                  <td>Severe Hair Loss</td>
                  <td>6–8</td>
                  <td>Every 3–4 weeks</td>
                  <td>Thicker, fuller hair after 5–6 sessions</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="chennaigfcblog-paragraph">
            Maintenance sessions every 6 months help sustain long-term hair regrowth in Chennai.
          </p>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">GFC vs PRP Hair Therapy in Chennai</h2>
          <p className="chennaigfcblog-paragraph">
            Many patients in Chennai compare PRP vs GFC therapy before deciding:
          </p>
          <div className="chennaigfcblog-table-container">
            <table className="chennaigfcblog-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>PRP Therapy</th>
                  <th>GFC Hair Therapy</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Growth Factor Concentration</td>
                  <td>Moderate</td>
                  <td>Highly concentrated</td>
                </tr>
                <tr>
                  <td>Sessions Needed</td>
                  <td>6–8</td>
                  <td>3–6</td>
                </tr>
                <tr>
                  <td>Downtime</td>
                  <td>Mild</td>
                  <td>Minimal</td>
                </tr>
                <tr>
                  <td>Effectiveness</td>
                  <td>Moderate</td>
                  <td>Fast &amp; consistent</td>
                </tr>
                <tr>
                  <td>Best For</td>
                  <td>Early thinning</td>
                  <td>All stages of hair loss</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="chennaigfcblog-paragraph chennaigfcblog-expert-insight">
            <span className="chennaigfcblog-bold-text">Expert Insight:</span>
            “GFC therapy gives faster, denser, and long-lasting hair regrowth compared to PRP. Visible results are seen in half the sessions.” – H-Cura Clinic Dermatologist, Chennai
          </p>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">Real Patient Results at H-Cura Clinic, Chennai</h2>
          <ul className="chennaigfcblog-list">
            <li className="chennaigfcblog-list-item">Hair fall stops within weeks</li>
            <li className="chennaigfcblog-list-item">New hair growth after 2–3 sessions</li>
            <li className="chennaigfcblog-list-item">Visible density improvement after 4–6 sessions</li>
          </ul>
          <p className="chennaigfcblog-paragraph">
            Patient testimonials highlight safe, natural, and effective hair regrowth without surgery.
          </p>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">Post-Treatment Care</h2>
          <ul className="chennaigfcblog-list">
            <li className="chennaigfcblog-list-item">Avoid washing hair for 24 hours post-treatment.</li>
            <li className="chennaigfcblog-list-item">Use mild, sulfate-free shampoos.</li>
            <li className="chennaigfcblog-list-item">Avoid chemical treatments for a few days.</li>
            <li className="chennaigfcblog-list-item">Maintain a protein-rich diet for follicle nourishment.</li>
            <li className="chennaigfcblog-list-item">Follow doctor-recommended scalp serums.</li>
          </ul>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">Why H-Cura Clinic Is the Top Choice in Chennai</h2>
          <ul className="chennaigfcblog-list">
            <li className="chennaigfcblog-list-item">Experienced dermatologists and hair specialists.</li>
            <li className="chennaigfcblog-list-item">State-of-the-art GFC extraction and injection technology.</li>
            <li className="chennaigfcblog-list-item">Customized treatment plans for each patient.</li>
            <li className="chennaigfcblog-list-item">High patient satisfaction with visible, long-lasting hair regrowth.</li>
            <li className="chennaigfcblog-list-item">Safe, non-surgical procedures with minimal downtime.</li>
          </ul>
          <p className="chennaigfcblog-paragraph">
            Whether you’re looking for advanced hair regrowth treatment, PRP vs GFC therapy, or natural hair restoration in Chennai, H-Cura Clinic is the trusted destination.
          </p>
        </div>

        <div className="chennaigfcblog-section chennaigfcblog-conclusion chennaigfcblog-fade-in">
          <h2 className="chennaigfcblog-heading">Conclusion</h2>
          <p className="chennaigfcblog-paragraph">
            If you’re experiencing hair thinning, receding hairline, or excessive hair fall in Chennai, GFC Hair Therapy at H-Cura Clinic is the most effective, safe, and natural solution.
          </p>
          <p className="chennaigfcblog-paragraph">
            With 3–6 sessions, you can achieve visible hair regrowth, and maintenance ensures long-lasting results. GFC therapy is faster, more effective, and safer than PRP, making it the best hair restoration solution in Chennai in 2025.
          </p>
          <p className="chennaigfcblog-paragraph chennaigfcblog-call-to-action">
            Take the first step towards stronger, healthier hair — visit H-Cura Clinic, Chennai, for a personalized consultation today.
          </p>
        </div>
      </div>

      {/* <div className="chennaigfcblog-download-section">
        <button className="chennaigfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Blog as PDF
        </button>
      </div> */}
    </>
  );
};

export default ChennaiGfc;
